import React, { useContext } from 'react';
import GlobalContext from '../GlobalContext';
import Loading from '../Loading/Loading';
import AppRoutes from '../AppRoutes';

import './Container.css';

function Container() {
  const global = useContext(GlobalContext);

  return (
    <business-directory>
      {global.state.initialized ? <AppRoutes /> : <Loading />}
    </business-directory>
  );
}

export default Container;